module.exports = __webpack_public_path__ + "img/Seite26-papa.a4fe7492.png";